import { usePageOverlay } from './pageOverlayHandler/usePageOverlayHandler';
import { LocationApiApiLocationCheckGet } from '@clients/AuthApi';
import VpnModal from '@components/util/VpnModal.vue';

const sessionKey = 'VPN_CHECK';

export const useVpnModal = () => {
    const pageOverlayHandler = usePageOverlay();
    const postHog = usePosthog();
    const analytics = useAnalyticsStore();
    const route = useRoute();
    const authStore = useAuthStore();

    const openVpnHandler = () => {
        const openingRoute = route.fullPath;
        setTimeout(async () => {
            if (openingRoute !== route.fullPath) {
                return;
            }
            try {
                const result = await pageOverlayHandler.addAsyncLayer({
                    component: VpnModal,
                    props: {},
                });
                if (result) {
                    analytics.trackAll('VPNPopup_clicked', {
                        path: route.fullPath,
                    });
                }
            } catch {
            } finally {
                analytics.trackAll('VPNPopup_shown', {
                    path: route.fullPath,
                });
                sessionStorage.setItem(sessionKey, JSON.stringify(true));
            }
        }, 5 * 1000);
        window.removeEventListener('click', openVpnHandler);
    };

    onMounted(async () => {
        const alerted = JSON.parse(
            sessionStorage.getItem(sessionKey) || 'false'
        );
        if (alerted) {
            return;
        }
        const { data } = await LocationApiApiLocationCheckGet();
        const enabled = postHog.value?.isFeatureEnabled('vpnpopuptest');
        authStore.setVpn(!!data.showMessage);
        if (enabled && data.showMessage) {
            window.addEventListener('click', openVpnHandler);
        }
    });
};
